"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _canUseDOM = _interopRequireDefault(require("./canUseDOM"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var getDomNode = function getDomNode(from) {
  /* istanbul ignore if */
  if (!from) {
    return null;
  }

  if (from instanceof Element) {
    return from;
  }

  return from.current;
};

var useClickOutside = function useClickOutside(ref, handler, options) {
  (0, _react.useEffect)(function () {
    /* istanbul ignore if */
    if (!_canUseDOM.default) {
      return undefined;
    }

    var onClick = function onClick(e) {
      /* istanbul ignore next didn't test passing a single ref */
      var refs = Array.isArray(ref) ? ref : [ref];
      var target = e.target;
      var isOutside = refs.map(function (item) {
        return getDomNode(item);
      }).filter(Boolean).every(function (refNode) {
        return !!refNode && !refNode.contains(target);
      });
      isOutside && handler(e);
    };

    document.addEventListener('click', onClick, options);
    return function () {
      return document.removeEventListener('click', onClick, options);
    };
  }, [ref, handler, options]);
};

var _default = useClickOutside;
exports.default = _default;